import { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { editarBreadcrumb } from '../../actions/breadcrumb';
import { cargarDetallesCliente, limpiarDetallesCliente } from '../../actions/clientes';

import ResumenCliente from './resumen/ResumenCliente';
import VentasCliente from './ventas/VentasCliente';
import PagosCliente from './pagos/PagosCliente';

const DetalleCliente = () => {
    const dispatch = useDispatch();
    const { id } = useParams();

    const { detalles: cliente, loadingDetalles } = useSelector(state => state.clientes || { detalles: null, loadingDetalles: false });

    const [tabActiva, setTabActiva] = useState(0);

    useEffect(() => {
        if (!id) return;

        dispatch(cargarDetallesCliente(id));

        return () => {
            dispatch(limpiarDetallesCliente());
        };
    }, [dispatch, id]);

    useEffect(() => {
        dispatch(editarBreadcrumb([
            { activo: false, nombre: 'Clientes', path: '/clientes' },
            { activo: true, nombre: cliente?.nombre || 'Detalle de cliente', path: `/clientes/detalle/${id}` }
        ]));
    }, [dispatch, id, cliente]);

    if (loadingDetalles || !cliente) {
        return (
            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="my-5">Cargando cliente...</h3>
                </div>
            </div>
        );
    }

    return (
        <Fragment>
            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="my-5 mb-1">{cliente?.nombre || 'Sin definir'}</h3>

                    <div className="row mb-4">
                        <div className="col-md-4">
                            <div className="text-muted small">Correo</div>
                            <div>{cliente?.correo || 'Sin definir'}</div>
                        </div>
                        <div className="col-md-4">
                            <div className="text-muted small">Teléfono</div>
                            <div>{cliente?.telefono || 'Sin definir'}</div>
                        </div>
                        <div className="col-md-4">
                            <div className="text-muted small">RFC</div>
                            <div>{cliente?.rfc || 'Sin definir'}</div>
                        </div>
                    </div>

                    <ul className="nav nav-tabs mb-3">
                        <li className="nav-item">
                            <button
                                type="button"
                                className={`nav-link${tabActiva === 0 ? ' active' : ''}`}
                                onClick={() => setTabActiva(0)}
                            >
                                Resumen
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                type="button"
                                className={`nav-link${tabActiva === 1 ? ' active' : ''}`}
                                onClick={() => setTabActiva(1)}
                            >
                                Ventas
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                type="button"
                                className={`nav-link${tabActiva === 2 ? ' active' : ''}`}
                                onClick={() => setTabActiva(2)}
                            >
                                Pagos
                            </button>
                        </li>
                    </ul>

                    {tabActiva === 0 && (
                        <ResumenCliente idCliente={id} />
                    )}

                    {tabActiva === 1 && (
                        <VentasCliente idCliente={id} />
                    )}

                    {tabActiva === 2 && (
                        <PagosCliente idCliente={id} />
                    )}
                </div>
            </div>
        </Fragment>
    );
};

export default DetalleCliente;
